import apiClient from './apiClient';

export const createRoute = async (routeData) => {
  const payload = {
    ...routeData,
    client_id: routeData.client_id || routeData.clientId
  };
  const response = await apiClient.post('/route/create', payload);
  return response.data;
};

export const getAllRoutes = async () => {
  const response = await apiClient.get('/route/getall');
  return response.data;
};

export const getRouteById = async (routeId) => {
  const response = await apiClient.get(`/route/get/${routeId}`);
  return response.data;
};

export const updateRoute = async (routeId, updateData) => {
  const response = await apiClient.put(`/route/update/${routeId}`, updateData);
  return response.data;
};

export const deleteRoute = async (routeId) => {
  const response = await apiClient.delete(`/route/delete/${routeId}`);
  return response.data;
};

export const toggleRouteStatus = async (routeId) => {
  const response = await apiClient.put(`/route/toggle-status/${routeId}`);
  return response.data;
};
